import { combineReducers } from 'redux';
import declarations from './declarationsReducer';
import history from './declarationsHistoryReducer';
import documents from './declarationsDocumentsReducer';
import propertyDeductionBalance from './propertyDeductionBalanceReducer';

export default combineReducers({
  declarations,
  history,
  documents,
  propertyDeductionBalance,
});
